import { FlightEventHandler } from './flight'
import { writable } from 'svelte/store'

export default class LinkLeads extends FlightEventHandler {
	linkLeads = {}

	constructor(flight) {
		super(flight)

		const { subscribe, set, update } = writable({});
		this.subscribe = subscribe 
		this.set = set
		this.update = update
	}

	handleKeyframe(keyframe) {
		if (keyframe.linkLeads) {
			this.linkLeads = JSON.parse(JSON.stringify(keyframe.linkLeads))
		} else {
			this.linkLeads = {}
		}
		this.set(this.linkLeads)
	}

	handleFlightStep(message) {
		switch(message.type) {
			case "LINK_ROAM":
				this.linkLeads[message.linkId] = message.currentId
				this.set(this.linkLeads)
				break
		}
	}
}
